// FormResponsesAdminTab.jsx — Admin Panel "Form Responses" sub-tab, extracted
// from LimitedPartnerPortal. Thin chrome pane-header + body wrapper around the
// shared FormResponses component (Forms Library submissions).
import React from "react";
import FormResponses from "../../forms-library/FormResponses";

export default function FormResponsesAdminTab({ user, isSuperAdmin }) {
  return (
            <>
              <div className="win95-pane-header">
                <div>
                  <div className="win95-pane-header__context">
                    Forms library · {isSuperAdmin ? "All chapters" : "Your chapter"}
                  </div>
                  <h2 className="win95-pane-header__title">Form responses</h2>
                </div>
              </div>
              <div className="admin-pane-body">
                <FormResponses user={user} isSuperAdmin={isSuperAdmin} />
              </div>
            </>
  );
}
